import React from 'react';

const AsyncVideoClipList = React.lazy(() => import('./ListContainer'));

export const VideoClipList = () => {
  return <AsyncVideoClipList />;
};
